import { AfterViewInit, Component, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ChartColor, ChartOptions } from "chart.js";
import { ProjectService } from "src/app/_services/project.service";
import { ReportService } from "src/app/_services/report.service";
import { UserService } from "src/app/_services/user.service";
import { HomeService } from "src/app/_services/home.service";
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import autoTable from 'jspdf-autotable';
import { SpinnerService } from "src/app/_services/spinner.service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { Moment } from 'moment';
import moment from 'moment';
import { TestService } from "src/app/_services/test.service";
import { WorkflowService } from "src/app/_services/workflow.service";



@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit, OnDestroy, AfterViewInit {
  headerOptions = {
    showSetting: false,
    showSearch: false,
    heading: "",
    data: undefined,
  };
  doughnutChartName = "Pareto Analysis for Cases";
  barChartName = "Automations Execution Stats";
  horizontalBarChartName = "Automation Stats";
  customDate: UntypedFormGroup;
  dateFilterForm: UntypedFormGroup;
  currentDate = new Date();
  selectedChart: any;
  currentUser: any;
  projectData: any;
  isProjectExist: boolean = false;
  selectedProject: any;
  moduleData: any;
  suiteData: any;
  moduleSuiteMap: any;
  usersData: any;
  toDate: any;
  fromDate: any;
  barGraphStartDate: any;
  barGraphEndDate: any;
  chartPlugins = [];
  chartLegend = true;
  chartLabels = [
    "Pass",
    "Fail",
    "Blocked",
    "Inconclusive",
    "Not Run",
    "Skipped",
  ];
  chartOptions: ChartOptions = {
    responsive: true,
    legend: {
      display: true,
      position: "bottom",
    },
  };
  chartBackgroundColor = [
    "rgba(57,181,74)",
    "rgba(237,58,18)",
    "rgba(240,45,91)",
    "rgba(213, 97, 40)",
    "rgb(92, 191, 223)",
    "rgb(103, 204, 170)",
  ];
  chartHoverBackgroundColor = [
    "rgba(43,155,58)",
    "rgba(191,40,6)",
    "rgba(207,32,73)",
    "rgba(160, 70, 26)",
    "rgb(65, 159, 189)",
    "rgb(69, 172, 137)",
  ];
  chartHoverBorderColor = [
    "rgba(43,155,58)",
    "rgba(191,40,6)",
    "rgba(207,32,73)",
    "rgba(205, 142, 56)",
    "rgb(65, 159, 189)",
    "rgb(69, 172, 137)",
  ];
 
  barChartBackgroundColor = [
    "rgb(92, 191, 223)",
    "rgb(0, 76, 153)",
    "rgba(241, 172, 77)",
    "rgb(57, 181, 74)",
    "rgb(57, 181, 74)",
    "rgb(102, 205, 170)",
    "rgb(0, 0, 255)",
    "rgb(102, 173, 204)",
    "rgb(255, 192, 127)",
    "rgb(128, 128, 128)",
  ];
  barChartHoverBackgroundColor = [
    "rgb(65, 159, 189)",
    "rgb(0, 76, 153)",
    "rgba(205, 142, 56)",
    "rgb(57, 181, 74)",
    "rgb(57, 181, 74)",
    "rgb(102, 205, 170)",
    "rgb(0, 0, 255)",
    "rgb(102, 173, 204)",
    "rgb(255, 192, 127)",
    "rgb(128, 128, 128)",
  ];
  barChartHoverBorderColor = [
    "rgb(92, 184, 92)",
    "rgb(0, 76, 153)",
    "rgb(57, 181, 74)",
    "rgb(57, 181, 74)",
    "rgb(57, 181, 74)",
    "rgb(102, 205, 170)",
    "rgb(0, 0, 255)",
    "rgb(102, 173, 204)",
    "rgb(255, 192, 127)",
    "rgb(128, 128, 128)",
  ];


  lineChartOptions: ChartOptions = {
    responsive: true,
    scales: {
      xAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Date range',
          },
          ticks: {
            stepSize: 1,
            maxTicksLimit: 10
          }
        }
      ],
      yAxes: [
        {
          ticks: {
            stepSize: 1,
            autoSkip: false,
            min: 0,
            maxTicksLimit: 10, // Adjust this value as needed
            callback: function (value: any, index, values: any) {
              return value;
            },
          },
          scaleLabel: {
            display: true,
            labelString: 'Time in seconds',
          },
          gridLines: {},
        },
      ],

    },
  };
  lineChartColors: any = [
    {
      borderColor: "red",
      backgroundColor: "red",
    },
    {
      borderColor: "#002d5b",
      backgroundColor: "#002d5b",
    },
  ];

  runTimeByOSBarChartOptions = {
    scaleShowVerticalLines: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Time in seconds',
           },
          stacked: true,
          ticks: {
            beginAtZero: true,
          },
        },
      ],
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'OS',
           },
          stacked: true,
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };

  autoSubCompBarChartOptions = {
    scaleShowVerticalLines: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Subcomponent count',
           },
          stacked: true,
          ticks: {
            beginAtZero: true,
          },
        },
      ],
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Subcomponent names',
           },
          stacked: true,
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };

  numAutoBarChartOptions = {
    scaleShowVerticalLines: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Number of automations',
           },
          stacked: true,
          ticks: {
            beginAtZero: true,
          },
        },
      ],
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Top 5 users',
           },
          stacked: true,
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };


  automationData = {};
  horizontalChartBackgroundColor = [
    "rgba(214,68,57, 0.9)",
    "rgba(54,162,235,0.9)",
    "rgba(0,45,91,0.9)",
    "rgba(176, 196, 222, 0.9)",
  ];
  horizontalChartHoverBackgroundColor = [
    "rgba(214,68,57, 1)",
    "rgba(54,162,235,1)",
    "rgba(0,45,91,0.9)",
    "rgba(176, 196, 222, 1)",
  ];
  horizontalChartHoverBorderColor = [
    "rgba(214,68,57, 1)",
    "rgba(54,162,235,1)",
    "rgba(0,45,91,0.9)",
    "rgba(176, 196, 222, 1)",
  ];

  horizontalChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    legend: {
      display: true,
      position: "bottom",
    },
    scales: {
      xAxes: [
        {          
          scaleLabel: {
          display: true,
          labelString: 'size of an automation',
         },
          stacked: true,
          ticks: {
            stepSize: 1,
            callback: (value, values, ctx) => {
              // when the floored value is the same as the value we have a whole number
              if (Math.floor(value) === value) {
                return value;
              }
            },
          },
        },
      ],
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Top 5 Automations',
           },
          stacked: true,
          ticks: {
            callback: (value, values, ctx) => {
              let name = value;
              if (value.length > 8) {
                name = name.slice(0, 8) + "...";
              }
              return name;
            },
          },
        },
      ],
    },
  };

  barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Top 10 automations',
           },
          stacked: true,
          ticks: {
            callback: (value, values, ctx) => {
              let name = value;
              if (value.length > 8) {
                name = name.slice(0, 8) + "...";
              }
              return name;
            },
          },
        },
      ],
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Time in seconds',
           },
          stacked: true,
          ticks: {
            stepSize: 1,
            autoSkip: false,
            min: 0,
            maxTicksLimit: 10, // Adjust this value as needed
            callback: function (value: any, index, values: any) {
              return value;
            },
          },
        },
      ],
    },
  };

  personalizedCharts: any = [];

  horizontalChartLabels: string[];
  barChartLabels: string[];
  horizontalChartData: any[] = [
    { data: [], label: "modules" },
    { data: [], label: "suites" },
    { data: [], label: "cases" },
    { data: [], label: "steps" },
  ];

  barChartData = [];
  doughnutChartData = [];

  // date picker related variables starts
  ranges: any = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Last 7 Days": [moment().subtract(6, "days"), moment()],
    "This Week": [moment().startOf("week"), moment()],
    "This Month": [moment().startOf("month"), moment()],
    "This Year": [moment().startOf("year"), moment()],
  };
  selected: { startDate: Moment; endDate: Moment } = { startDate: moment().startOf("month"), endDate:  moment() };
  calendarPlaceholder: string = "Select a date range";
  maxDate = moment();
  showDateRange : boolean = true;
  // date picker related variables ends

  graphList = [];
  graphListResponse: any;
  graphTypeMap: any;

  graphTooltipMap = {
    "1": "This chart represents sucess-failure statistics of an automation",
    "2": "This chart represent the count of module, suite, cases and steps of the automation",
    "3": "This chart represent the automation execution count",
    "4": "This graph represents the cumulative running time for automation.",
    "5": "This graph compares the duration to complete a full automation and a module",
    "6": "This graph shows us the automation runtime across the users",
    "7": "This bar chart shows top 5 users holding highest number of automations",
    "8": "This bar graph represents the number of modules present inside a particular automation",
    "9": "This Line graph represents an automation being run over different periods of time and how long it took to run",
    "10":"This chart compares the time taken to complete an automation in different OS machines",
    "11":"This line chart represents the time taken by a user to complete an automation in different time periods",
    "12":"This chart represents the time taken to execute a suite"
  };

  automationArray = ['1', '4', "5", "6", "8", "9", '10', '11', "12"];
  datesArray = ['3','4', "5","6", '9', "11","12"];

  graphNameMap: any;
  graphOrderMap: any;

  draggedGraph: string;
  relocate: boolean = false;
  dropIndex: number;
  searchText: string = "";
  isGraphDropped: boolean = false;
  graphOrder : any;
  moduleList: any;
  suiteList: any;
  enablewf: boolean = false;

  constructor(
    private userService: UserService,
    private projectService: ProjectService,
    private reportService: ReportService,
    private testService: TestService,
    private formBuilder: UntypedFormBuilder,
    private spinnerService: SpinnerService,
    private toastrService: ToastrService,
    private router: Router,
    private homeService: HomeService,
    private workFlowService: WorkflowService
  ) {  }

  goToHome() {
    this.router.navigate(["/project/home"]);
  }
  ngOnInit() {
    //set header details
    this.homeService.setHeaderOptions(this.headerOptions);

    this.initFromToDate();
    this.initForms();
    this.getAllProjectData();
    this.changeDateFilter();
    this.loadfeatureflag();

    if (!JSON.parse(localStorage.getItem("currentUser"))) {
      this.userService.getUser().subscribe((data) => {
        this.projectService.setUserDetails(data);
        this.currentUser = data;
        this.authenticateWfUser(this.currentUser.id)
        localStorage.setItem("currentUser", JSON.stringify(data));
        localStorage.removeItem("selectedProject");
      });
    } else {
      this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
      this.authenticateWfUser(this.currentUser.id)
      this.projectService.setUserDetails(this.currentUser);
      localStorage.removeItem("selectedProject");
    }
  }
authenticateWfUser(userId:any){
  this.projectService.authenticateUser(userId).subscribe(
    (res)=>{

    }
  )
}
  loadfeatureflag(){
    this.projectService.loadFeatureFlag().subscribe(
      (data:any)=>{
        this.enablewf = data[0].enabled
      }
    )
  }

  getAllProjectData() {
    this.projectService.getAllProjects().subscribe((data) => {
      localStorage.setItem("allProjects", JSON.stringify(data["project"]));
      this.getGraphList();
      this.projectData = data["project"];
      this.isProjectExist = this.projectData ? true : false;
      if (this.isProjectExist) {
        this.selectedProject = this.projectData[0].id;
      }
      else
      {
        this.selectedProject = undefined;
      }
    });
  }

  getGraphList()
  {
    this.projectService.getGraphList().subscribe((response: any)=>
    {
      this.graphListResponse = response['graphList'];
      this.graphList = [];
      this.graphTypeMap = {};
      this.graphNameMap = {};
      response.graphList.forEach(graph => {
        this.graphList.push(graph.graphName);
        this.graphTypeMap[graph.graphName] = graph;
        this.graphNameMap[graph.graphCode] = graph.graphName;
      });
      this.setDefaultGraphOrder();
    })
  }

  setDefaultGraphOrder() {
    this.projectService.getGraphOrder().subscribe((res: any) => {

      if (res.orderDataList) {
        this.graphOrder =  res;
      }
      else{
        let orderList = [];
        this.graphListResponse.forEach(element => {
          let obj = { graphName : element.graphName, order : element.graphCode};
          orderList.push(obj);
        });

        let graphData = { orderDataList : orderList}
        this.graphOrder = graphData;
      }

      this.graphOrderMap = {};
      this.graphOrder.orderDataList.forEach((element) => {
        this.graphOrderMap[element["graphName"]] = Number(element["order"]);
      });

      this.isGraphDropped = false;
      let graphNames = Object.keys(this.graphOrderMap);
      graphNames.forEach((element) => {
        let obj = { title: "Loading" };
        this.personalizedCharts.push(obj);
      });
      
      if(res.filterList && this.projectData)
      {
        res.filterList.forEach(filter => {
            if(filter.type == 'global')
            {
              switch (filter.filterName) {
                case "automation":
                  this.selectedProject = filter.value;
                  break;
                case "startDate":
                  this.selected.startDate = moment(Number(filter.value));
                  break;
                case "endDate":
                  this.selected.endDate = moment(Number(filter.value));
                  break;
                default:
                  break;
              }
            }
        });
      }

      this.getAutomationModules(false, false);

      // this.barGraphStartDate = new Date(this.selected.startDate.toDate()).getTime();
      // this.barGraphEndDate = new Date(this.selected.endDate.toDate()).getTime();

      this.showDateRange = false;
      setTimeout(()=>
      {
        this.showDateRange = true;
      }, 0)

      this.loadAllGraphs();
    });
  }
  //this functional sets the right order according to user preference 
  setGraphOrder(graphData) {
    if(graphData.title == 'Drop Container')
    {
      this.personalizedCharts.push(graphData);
    }
    else
    {
      this.personalizedCharts[this.graphOrderMap[graphData.title] - 1] = graphData;
    }
  }

  loadGraphs(projectId) {
    let startDate = new Date(JSON.parse(JSON.stringify(this.fromDate)));
    startDate.setHours(0, 0, 0);
    let endDate = new Date(JSON.parse(JSON.stringify(this.toDate)));
    endDate.setHours(23, 59, 59);

    this.selectedProject = projectId;
    let fDate = Math.floor(new Date(startDate).getTime());
    let tDate = Math.floor(new Date(endDate).getTime());
    this.reportService
      .getProjectReport(this.selectedProject, fDate, tDate, "All", "All", null)
      .subscribe((res) => {
        let clubedData;
        let data = [];
        data.push(res["projectLevelSummary"].pass);
        data.push(res["projectLevelSummary"].fail);
        data.push(res["projectLevelSummary"].blocked);
        data.push(res["projectLevelSummary"].inconclusive);
        data.push(res["projectLevelSummary"].notRun);
        data.push(res["projectLevelSummary"].skipped);

        clubedData = {
          backgroundColor: this.chartBackgroundColor,
          hoverBackgroundColor: this.chartHoverBackgroundColor,
          hoverBorderColor: this.chartHoverBorderColor,
        };

        clubedData["data"] =
          res["projectLevelSummary"].totalTests != "0"
            ? data
            : [0, 0, 0, 0, 1, 0];

        this.doughnutChartData = [];
        this.doughnutChartData.push(clubedData);

        let chartData = {
          index: this.personalizedCharts.length,
          title: this.graphNameMap["1"],
          tooltip: this.graphTooltipMap["1"],
          type: "doughnut",
          chart: this.doughnutChartData,
          labels: this.chartLabels,
          options: this.chartOptions,
          legend: true,
          inputs: [],
        };

        console.log("working ", chartData);
        if (this.isGraphDropped) {
          this.personalizedCharts.splice(this.dropIndex, 1, chartData);
          this.saveOrderToDb();
        } else {
          this.setGraphOrder(chartData);
        }

        this.manageDropContainer();
      });
  }

  loadAutomationHierarchyCount() {
    this.projectService.getProjectHierarchyCount().subscribe((data) => {
      let response = data;
      let projectNames = this.filterTop5Projects(
        response,
        Object.keys(response)
      );
      let projectDetails = {};
      projectNames.forEach((name) => {
        let splitIndex = name.indexOf("_");
        let result = name.substring(splitIndex + 1);
        projectDetails[name] = result;
      });

      projectNames.forEach((element) => {
        this.automationData[projectDetails[element]] = {
          modules: response[element].testModuleCount,
          suites: response[element].testSuiteCount,
          cases: response[element].testCaseCount,
          steps: response[element].testStepCount,
        };
      });

      this.horizontalChartLabels = Object.keys(this.automationData);
      let hierarchy = ["modules", "suites", "cases", "steps"];
      this.horizontalChartLabels.forEach((label, i) => {
        this.horizontalChartData.forEach((element, j) => {
          element.data.push(this.automationData[label][hierarchy[j]]);
        });
      });

      this.horizontalChartData.forEach((element, i) => {
        element["backgroundColor"] = this.horizontalChartBackgroundColor[i];
        element["borderColor"] = this.horizontalChartHoverBorderColor[i];
        element["hoverBackgroundColor"] =
          this.horizontalChartHoverBackgroundColor[i];
        element["hoverBorderColor"] = this.horizontalChartHoverBorderColor[i];
      });

      let chartData = {
        index: this.personalizedCharts.length,
        title: this.graphNameMap["2"],
        tooltip: this.graphTooltipMap["2"],
        type: "horizontalBar",
        chart: this.horizontalChartData,
        labels: this.horizontalChartLabels,
        options: this.horizontalChartOptions,
        legend: true,
        inputs: [],
      };
      if (this.isGraphDropped) {
        this.personalizedCharts.splice(this.dropIndex, 1, chartData);
        this.saveOrderToDb();
      } else {
        this.setGraphOrder(chartData);
      }

      this.manageDropContainer();
    });
  }

  loadAutomationExecutionCount() {
    this.projectService
      .getProjectExecutionCount(this.barGraphStartDate, this.barGraphEndDate)
      .subscribe((response) => {
        console.log("working", response);
        this.barChartLabels = [];
        let projectNames = this.filterTop10Projects(
          response,
          Object.keys(response)
        );
        let data = [];

        projectNames.forEach((name) => {
          let splitIndex = name.indexOf("_");
          let result = name.substring(splitIndex + 1);
          let totalCount = response[name].testExecutionStats[0]
            ? response[name].testExecutionStats[0].totalTests
            : 0;
          this.barChartLabels.push(result);
          data.push(totalCount);
        });

        let clubedData = {
          data: data,
          backgroundColor: this.barChartBackgroundColor,
          hoverBackgroundColor: this.barChartHoverBackgroundColor,
          hoverBorderColor: this.barChartHoverBorderColor,
        };

        this.barChartData = [];
        this.barChartData.push(clubedData);
        let chartData = {
          index: this.personalizedCharts.length,
          title: this.graphNameMap["3"],
          tooltip: this.graphTooltipMap["3"],
          type: "bar",
          chart: this.barChartData,
          labels: this.barChartLabels,
          options: this.barChartOptions,
          legend: false,
          inputs: [],
        };

        if (this.isGraphDropped) {
          this.personalizedCharts.splice(this.dropIndex, 1, chartData);
          this.saveOrderToDb();
        } else {
          this.setGraphOrder(chartData);
        }

        this.manageDropContainer();
      });
  }

  loadUserAutomationCount()
  {
    this.projectService.getAutomationCountAcrossUsers().subscribe((res: any)=>
    {
        console.log(res);
        let clubedData = [];
        let labelData = [];
        if(res.userAutomations)
        {
          res.userAutomations.forEach(element => {
            clubedData.push(element.count);
            labelData.push(element.userName);
          });
        }

        let chartData = {
          index: this.personalizedCharts.length,
          title: this.graphNameMap["7"],
          tooltip: this.graphTooltipMap["7"],
          type: "horizontalBar",
          chart: [
            {
              data: clubedData,
              label: "Automations",
              backgroundColor: "#002d5b",
              borderColor: "#124176",
              hoverBackgroundColor:"#124176"
            },
          ],
          labels: labelData,
          options: this.numAutoBarChartOptions,
          legend: true,
          inputs: []
        };

        if (this.isGraphDropped) {
          this.personalizedCharts.splice(this.dropIndex, 1, chartData);
          this.saveOrderToDb();
        } else {
          this.setGraphOrder(chartData);
        }

        this.manageDropContainer();
    })
  }

  loadSingleAutomationHierarchy()
  {
    this.projectService.getSingleAutomationHierarchy(this.selectedProject).subscribe((res: any)=>
    {
      let clubedData = [];
      clubedData.push(res.testModuleCount);
      clubedData.push(res.testSuiteCount);
      clubedData.push(res.testCaseCount);
      clubedData.push(res.testStepCount);
      let labelData = ['Module', 'Suite', 'Case', 'Step'];

      let chartData = {
        index: this.personalizedCharts.length,
        title: this.graphNameMap["8"],
        tooltip: this.graphTooltipMap["8"],
        type: "horizontalBar",
        chart: [
          {
            data: clubedData,
            label: "Subcomponents",
            backgroundColor: "#002d5b",
            borderColor: "#124176",
            hoverBackgroundColor:"#124176"
          },
        ],
        labels: labelData,
        options: this.autoSubCompBarChartOptions,
        legend: true,
        inputs: []
      };

      if (this.isGraphDropped) {
        this.personalizedCharts.splice(this.dropIndex, 1, chartData);
        this.saveOrderToDb();
      } else {
        this.setGraphOrder(chartData);
      }

      this.manageDropContainer();
    })
  }

  getRuntimeByAutomation()
  {
    this.projectService.getRuntimeByAutomation(this.selectedProject,this.barGraphStartDate, this.barGraphEndDate).subscribe((res)=>
    {
      let response = res;
      let duration = [];
      let labels = [];

      if(response['runTimePeriodList'])
      {
        response['runTimePeriodList'].forEach(element => {
          let date = new Date(element.date);
          const year = date.getFullYear();
          const month = date.toLocaleString('default', { month: 'short' });
          const day = date.getDate();
          duration.push(element.duration);
          labels.push(`${day} ${month} ${year}`);
      });
      }

      let data = [
        {
          data: duration,
          label: "Automation",
          fill: false,
          backgroundColor: "#2B7ACB",
          borderColor: "#39b54a",
          tension: 0,
          pointBackgroundColor: "#39b54a",
        },
      ];
  
      let clubedData = {
        title: this.graphNameMap["9"],
        tooltip: this.graphTooltipMap["9"],
        type: "line",
        chart: data,
        labels: labels,
        options: this.lineChartOptions,
        legend: true,
        inputs: []
      };

      if (this.isGraphDropped) {
        this.personalizedCharts.splice(this.dropIndex, 1, clubedData);
        this.saveOrderToDb();
      } else {
        this.setGraphOrder(clubedData);
      }

      this.manageDropContainer();

    })
  }

  getAutomationModules(loadModule, loadSuite)
  {
    this.testService.getAllChildTestDir(this.selectedProject).subscribe((res: any)=>
    {
      let moduleList = res["testSuiteDirData"];
      let suiteList = res['testSuiteFileData'];
      if(moduleList)
      {
        this.moduleData = [];
        this.suiteData = [];
        this.moduleSuiteMap = {};
        moduleList.forEach(element => {
            let obj = {id: element.id, name: element.title};
            this.moduleData.push(obj);
        });

        suiteList.forEach(suiteData => {
          let obj = {id: suiteData.id, name: suiteData.title, parent: suiteData.parentTestDataId}
          this.suiteData.push(obj);
          if(this.moduleSuiteMap[suiteData.parentTestDataId])
          {
            this.moduleSuiteMap[suiteData.parentTestDataId].push(obj);
          }
          else
          {
            this.moduleSuiteMap[suiteData.parentTestDataId] = [];
            this.moduleSuiteMap[suiteData.parentTestDataId].push(obj);
          }
        });

        console.log("module suite map : ", this.moduleSuiteMap);
        let moduleIds = Object.keys(this.moduleSuiteMap);

        if(loadModule && this.moduleData[0])
        {
          this.getAutomationVsModuleRuntime(this.moduleData[0].id)
        }
        else if(loadSuite && this.moduleSuiteMap[moduleIds[0]].length > 0)
        {
          this.getSuiteRuntime(this.moduleSuiteMap[moduleIds[0]][0]);
        }

      }
    })
  }

  getAutomationVsModuleRuntime(moduleId)
  {
    console.log("chartData : ",this.personalizedCharts);
    this.projectService.getAutomationVsModuleRuntime(this.selectedProject, moduleId ,this.barGraphStartDate, this.barGraphEndDate).subscribe((res)=>
    {
      let automationDuration = [];
      let automationLabels = [];
      let moduleDuration = [];
      let moduleData = {};

      if(res['module'])
      {
        res['module'].forEach(element => {
          moduleData[element.date] = element.duration;
        });
      }

      if(res['automation'])
      {
        res['automation'].forEach(element => {
          let date = new Date(element.date);
          const year = date.getFullYear();
          const month = date.toLocaleString('default', { month: 'short' });
          const day = date.getDate();
          automationDuration.push(element.duration);
          let duration = moduleData[element.date] ? moduleData[element.date] : 0;
          moduleDuration.push(duration);
          automationLabels.push(`${day} ${month} ${year}`);
      });
      }

      let data = [
        {
          data: automationDuration,
          label: "Automation",
          fill: false,
          borderColor: "#39b54a",
          tension: 0,
          pointBackgroundColor: "#39b54a",
        },
        {
          data: moduleDuration,
          label: "Module",
          fill: false,
          borderColor: "#053367",
          tension: 0,
          pointBackgroundColor: "#053367",
          pointBorderColor: "#053367",
          borderWidth : 6,
          pointRadius: 2,
        },
      ];
  
      let clubedData = {
        title: this.graphNameMap["5"],
        tooltip: this.graphTooltipMap["5"],
        type: "line",
        chart: data,
        labels: automationLabels,
        options: this.lineChartOptions,
        legend: true,
        inputs: []
      };

      clubedData["inputs"] = [{name: 'module', options: this.moduleData, value : moduleId}];
      console.log("module data : ", clubedData);
      if (this.isGraphDropped) {
        this.personalizedCharts.splice(this.dropIndex, 1, clubedData);
        this.saveOrderToDb();
      } else {
        this.setGraphOrder(clubedData);
      }

      this.manageDropContainer();
    })
  }

  getRuntimeByOS()
  {
    this.projectService.getRuntimeByOS(this.selectedProject, this.barGraphStartDate, this.barGraphEndDate).subscribe((res: any)=>
    {

      let clubedData = [];
      let labelData = [];
      if(res['runTimeOsList'])
      {
        res.runTimeOsList.forEach((element: any) => {
          clubedData.push(element.duration);
          labelData.push(element.os);
        });
      }


      let chartData = {
        index: this.personalizedCharts.length,
        title: this.graphNameMap["10"],
        tooltip: this.graphTooltipMap["10"],
        type: "horizontalBar",
        chart: [
          {
            data: clubedData,
            label: "Runtime",
            backgroundColor: "#002d5b",
            borderColor: "#124176",
            hoverBackgroundColor:"#124176"
          },
        ],
        labels: labelData,
        options: this.runTimeByOSBarChartOptions,
        legend: true,
        inputs: []
      };

      if (this.isGraphDropped) {
        this.personalizedCharts.splice(this.dropIndex, 1, chartData);
        this.saveOrderToDb();
      } else {
        this.setGraphOrder(chartData);
      }

      this.manageDropContainer();
    })
  }

  getUserList()
  {
    this.projectService.getUserList().subscribe((res: any) => {
      this.usersData = [];
      if(res.length > 0)
      {
        res.forEach(element => {
          let obj = { id: element.id, name: element.name};
          this.usersData.push(obj);
        });
        this.getRuntimeByUser(this.usersData[0].name);
      }
    });
  }

  getRuntimeByUser(userName: string)
  {
    this.projectService.getRuntimeByUser(this.selectedProject, userName, this.barGraphStartDate, this.barGraphEndDate).subscribe((res: any)=>
    {
      let response = res;
      let duration = [];
      let labels = [];

      if(response['runTimeByUserList'])
      {
        response['runTimeByUserList'].forEach(element => {
          let date = new Date(element.date);
          const year = date.getFullYear();
          const month = date.toLocaleString('default', { month: 'short' });
          const day = date.getDate();
          duration.push(element.duration);
          labels.push(`${day} ${month} ${year}`);
      });
      }

      let data = [
        {
          data: duration,
          label: "Automation",
          fill: false,
          backgroundColor: "#CDEBFF",
          borderColor: "#39b54a",
          tension: 0,
          pointBackgroundColor: "#39b54a",
        },
      ];
  
      let clubedData = {
        title: this.graphNameMap["11"],
        tooltip: this.graphTooltipMap["11"],
        type: "line",
        chart: data,
        labels: labels,
        options: this.lineChartOptions,
        legend: true,
        inputs: []
      };

      clubedData["inputs"] = [{name: 'user', options: this.usersData, value : userName}];

      if (this.isGraphDropped) {
        this.personalizedCharts.splice(this.dropIndex, 1, clubedData);
        this.saveOrderToDb();
      } else {
        this.setGraphOrder(clubedData);
      }

      this.manageDropContainer();

    })
  }

  loadAutomationRuntimeAcrossUsers()
  {
    this.projectService.getAutomationRuntimeAcrossUsers(this.selectedProject, this.barGraphStartDate, this.barGraphEndDate).subscribe((res: any)=>
    {
      console.log(" response : ",res);
      let clubedData;
      let duration = [];
      let labels = [];
      if(res['runTimeCountList'])
      {
        res['runTimeCountList'].forEach(element => {
          duration.push(element.testDuration)
          labels.push(element.userName);
        });
      }

      clubedData = {
        data: duration,
        backgroundColor: this.chartBackgroundColor,
        hoverBackgroundColor: this.chartHoverBackgroundColor,
        hoverBorderColor: this.chartHoverBorderColor,
      };

      let plotData = [];
      plotData.push(clubedData);

        let chartData = {
          index: this.personalizedCharts.length,
          title: this.graphNameMap["6"],
          tooltip: this.graphTooltipMap["6"],
          type: "doughnut",
          chart: plotData,
          labels: labels,
          options: this.chartOptions,
          legend: true,
          inputs: [],
        };

        console.log("working ", chartData);
        if (this.isGraphDropped) {
          this.personalizedCharts.splice(this.dropIndex, 1, chartData);
          this.saveOrderToDb();
        } else {
          this.setGraphOrder(chartData);
        }

        this.manageDropContainer();
      });

  }

  getCumulativeAutomationRuntime()
  {
    this.projectService.getCumulativeAutomationRuntime(this.selectedProject, this.barGraphStartDate, this.barGraphEndDate).subscribe((res)=>
    {
      let response = res;
      let duration = [];
      let labels = [];

      if (res["runTimeCumulativeList"]) {
        response["runTimeCumulativeList"].forEach((element) => {
          let date = new Date(element.date);
          const year = date.getFullYear();
          const month = date.toLocaleString("default", { month: "short" });
          const day = date.getDate();
          duration.push(element.duration);
          labels.push(`${day} ${month} ${year}`);
        });
      }

      console.log("labels : ", labels);
      let data = [
        {
          data: duration,
          label: "Automation",
          fill: false,
          backgroundColor: "#CDEBFF",
          borderColor: "#39b54a",
          tension: 0,
          pointBackgroundColor: "#39b54a",
        },
      ];

      let clubedData = {
        title: this.graphNameMap["4"],
        tooltip: this.graphTooltipMap["4"],
        type: "line",
        chart: data,
        labels: labels,
        options: this.lineChartOptions,
        legend: true,
        inputs: []
      };

      if (this.isGraphDropped) {
        this.personalizedCharts.splice(this.dropIndex, 1, clubedData);
        this.saveOrderToDb();
      } else {
        this.setGraphOrder(clubedData);
      }

      this.manageDropContainer();

    })

  }
  

  getSuiteRuntime(suiteData)
  {
    this.projectService.getSuiteRuntime(this.selectedProject, suiteData.id, this.barGraphStartDate, this.barGraphEndDate).subscribe((res)=>
    {
      let response = res;
      let duration = [];
      let labels = [];

      if (res["runTimeBySuiteList"]) {
        response["runTimeBySuiteList"].forEach((element) => {
          let date = new Date(element.date);
          const year = date.getFullYear();
          const month = date.toLocaleString("default", { month: "short" });
          const day = date.getDate();
          duration.push(element.duration);
          labels.push(`${day} ${month} ${year}`);
        });
      }
      let data = [
        {
          data: duration,
          label: "Suite",
          fill: false,
          backgroundColor: "#CDEBFF",
          borderColor: "#39b54a",
          tension: 0,
          pointBackgroundColor: "#39b54a",
        },
      ];

      let clubedData = {
        title: this.graphNameMap["12"],
        tooltip: this.graphTooltipMap["12"],
        type: "line",
        chart: data,
        labels: labels,
        options: this.lineChartOptions,
        legend: true,
        inputs: []
      };

      clubedData["inputs"] = [{name: 'module2', options: this.moduleData, value : suiteData.parent}, { name: 'suite', options: this.suiteData, value : suiteData.id }];

      if (this.isGraphDropped) {
        this.personalizedCharts.splice(this.dropIndex, 1, clubedData);
        this.saveOrderToDb();
      } else {
        this.setGraphOrder(clubedData);
      }

      this.manageDropContainer();

    })
  }

  loadAllGraphs() {
    this.isGraphDropped = false;
    let graphData: any = JSON.parse(localStorage.getItem("graphData"));
    console.log(graphData);
    if (graphData) {
      this.personalizedCharts = [];
      let chartData = [];
      graphData.graphDetails.forEach((element: any) => {
        if (this.originalVersionConverter(element) != null) {
          chartData.push(this.originalVersionConverter(element));
        }
      });

      Object.keys(this.graphOrderMap).forEach(title => {
          let graphData = chartData.find((chart)=> chart.title == title);
          //If chart exist locally, we are picking it from local storage, or else we are making new API to fetch.
          if(graphData)
          {
            this.setGraphOrder(graphData)
          }
          else
          {
            this.loadSingleChart(title);
          }
      });

      chartData.forEach((element: any) => {
          this.setGraphOrder(element);
      });
      this.manageDropContainer();

      console.log("final1 : ", this.personalizedCharts);
    } else {
      if(!this.graphOrder.orderDataList)
      {
        this.graphList.forEach((element) => {
          let obj = { title: "Loading" };
          this.personalizedCharts.push(obj);
        });
      }
      this.graphList.forEach((element) => {
        this.loadSingleChart(element);
      });
    }
  }

  loadSingleChart(element)
  {
    // let selectedGraphType = this.graphTypeMap[element].graphCode;
    this.dragStarted(element, false);
    this.graphDropped(this.personalizedCharts.length, false);
  }

  refreshSingleChart(graphName: string)
  {
    let position;
    this.personalizedCharts.forEach((graph, i)=>
    {
        if(graph.title == graphName)
        {
          position = i;
        }
    })
    this.isGraphDropped = false;
    let obj = { title: "Loading" };
    this.personalizedCharts.splice(position, 1, obj);
    this.loadSingleChart(graphName);
  }

  refreshAllCharts()
  { 
    if (this.graphOrderMap) {
      this.isGraphDropped = false;
      this.personalizedCharts = [];
      Object.keys(this.graphOrderMap).forEach((element) => {
        let obj = { title: "Loading" };
        this.personalizedCharts.push(obj);
      });
      Object.keys(this.graphOrderMap).forEach((element) => {
        this.loadSingleChart(element);
      });

    }
  }

  filterTop10Projects(projectList, keys) {
    let values = [];
    keys.forEach((element, i) => {
      let sum = projectList[element].testExecutionStats[0]
        ? projectList[element].testExecutionStats[0].totalTests
        : 0;
      let obj = { name: element, sum: sum };
      values.push(obj);
    });

    let topValues = values.sort((a, b) => b.sum - a.sum).slice(0, 10);
    let result = topValues.map((element) => element.name);
    return result;
  }

  filterTop5Projects(projectList, keys) {
    let values = [];
    keys.forEach((element, i) => {
      let sum =
        projectList[element].testModuleCount +
        projectList[element].testSuiteCount +
        projectList[element].testCaseCount +
        projectList[element].testStepCount;
      let obj = { name: element, sum: sum };
      values.push(obj);
    });

    let topValues = values.sort((a, b) => b.sum - a.sum).slice(0, 5);
    let result = topValues.map((element) => element.name);
    return result;
  }

  initFromToDate() {
    //Today
    var today = new Date();
    var year = today.getFullYear();
    var month = String(today.getMonth() + 1).padStart(2, "0");
    var date = String(today.getDate()).padStart(2, "0");
    this.toDate = year + "-" + month + "-" + date;
    let endDate = new Date(JSON.parse(JSON.stringify(this.toDate)));
    endDate.setHours(23);
    endDate.setMinutes(59);
    endDate.setSeconds(59);

    //Last Month date
    const now = new Date();
    var lastWeek = new Date(now.getFullYear(), now.getMonth(), 1);
    var year1 = lastWeek.getFullYear();
    var month1 = String(lastWeek.getMonth() + 1).padStart(2, "0");
    var date1 = String(lastWeek.getDate()).padStart(2, "0");
    this.fromDate = year1 + "-" + month1 + "-" + date1;
    let startDate = new Date(JSON.parse(JSON.stringify(this.fromDate)));
    startDate.setHours(0, 0, 0);
  }

  initForms() {
    this.initCustomDateForm();
    this.initDateFilterForm();
  }

  initCustomDateForm() {
    this.customDate = this.formBuilder.group({
      start: [""],
      end: [""],
    });
  }

  initDateFilterForm() {
    this.dateFilterForm = this.formBuilder.group({
      dateRange: ["month"],
    });
  }

  changeDateFilter() {
    let dateRange = this.dateFilterForm.value.dateRange;
    let today = new Date();
    switch (dateRange) {
      case "day":
        this.barGraphStartDate = new Date().setHours(0, 0, 0);
        this.barGraphEndDate = new Date().setHours(23, 59, 59);
        break;
      case "week":
        this.barGraphStartDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() - 7
        ).setHours(0, 0, 0);
        this.barGraphEndDate = new Date().setHours(23, 59, 59);
        break;
      case "month":
        this.barGraphStartDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          1
        ).setHours(0, 0, 0);
        this.barGraphEndDate = new Date().setHours(23, 59, 59);
        break;
      case "year":
        this.barGraphStartDate = new Date(today.getFullYear(), 0, 1).setHours(
          0,
          0,
          0
        );
        this.barGraphEndDate = new Date().setHours(23, 59, 59);
        break;
      default:
        break;
    }
    console.log(this.barGraphStartDate, this.barGraphEndDate);
    this.initCustomDateForm();
  }

  onCustomDateChange() {
    if (this.customDate.value.end) {
      this.dateFilterForm.patchValue({
        dateRange: "",
      });
      this.barGraphStartDate = new Date(this.customDate.value.start).setHours(
        0,
        0,
        0
      );
      this.barGraphEndDate = new Date(this.customDate.value.end).setHours(
        23,
        59,
        59
      );
      this.loadAutomationExecutionCount();
    }
  }

  header(doc) {
    var headerText = "HuLoop Executive Analytics Report";
    doc.text(headerText, 350, 25, null);
    doc.line(350, 30, 350 + doc.getTextWidth(headerText), 30);
  }

  addImage(doc, imageSource, imageType) {
    var img = new Image();
    img.src = imageSource;
    doc.addImage(img, imageType, 50, 850, 70, 30);
  }

  addDescription(doc, chartData)
  {
    const pdfWidth = doc.internal.pageSize.getWidth();
    const pdfHeight = doc.internal.pageSize.getHeight();
    let leftPadding = 30;
    let lineHeight = 2; // Adjust the line height as needed
    let heading = 'Description : ';
    let currentY = 660;
    doc.setFont('helvetica', 'bold');

    doc.text(10 + leftPadding, currentY, heading, {  align: 'left' });

    doc.setFont('helvetica', 'normal');
    currentY += lineHeight * 20;
    let selectedGraphType = this.graphTypeMap[chartData.title].graphCode;
    let description = this.getGraphDescription(chartData, selectedGraphType);
    const splitDescription = doc.splitTextToSize(description, pdfWidth - 30 - leftPadding);

    for (const line of splitDescription) {
      doc.text(10 + leftPadding, currentY, line);
      currentY += lineHeight * 10; // Adjust the multiplier for line height
    }
    
  }

  footer(doc, pageNumber) {
    this.addImage(doc, "assets/newImages/executive_report_logo.png", "png");
    var options = {
      orientation: "p",
      unit: "mm",
      format: "a4",
      putOnlyUsedFonts: true,
      floatPrecision: 16, // or "smart", default is 16
    };
    doc.text(" " + pageNumber, 450, 870, options); //print number bottom right
  }

  async exportPdfReport() {
    this.spinnerService.isLoading.next(true);
    this.toastrService.clear();
    this.toastrService.success("Exporting report...");
    var pdfFile = new jspdf.jsPDF("p", "pt", [900, 900]);
    pdfFile.setFontSize(11);
    var pageNumber = 1;

    await html2canvas(document.getElementById("ExecutiveReportFrontPage"), {
      onclone: function (clonedDoc) {
        clonedDoc.getElementById("ExecutiveReportFrontPage").style.display =
          "block";
      },
    }).then((canvas) => {
      var imgData = canvas.toDataURL("image/jpeg", 1.0);
      pdfFile.addImage(imgData, 0, 0, canvas.width, canvas.height);
    });

    this.personalizedCharts.forEach(async (chart, index) => {
      if (chart.title.replaceAll(" ", "-") != "Drop-Container") {
        let id = chart.title.replaceAll(" ", "-");

        await html2canvas(document.getElementById(id)).then((canvas) => {
          pdfFile.addPage();
          this.header(pdfFile);
          var imgData = canvas.toDataURL("image/jpeg", 1.0);
          pdfFile.addImage(imgData, 200, 200, canvas.width, canvas.height);
          this.addDescription(pdfFile, chart);
          this.footer(pdfFile, pageNumber++);
        });
      }
    });

    await html2canvas(document.getElementById("ExecutiveReportLastPage"), {
      onclone: function (clonedDoc) {
        clonedDoc.getElementById("ExecutiveReportLastPage").style.display =
          "block";
      },
    }).then((canvas) => {
      pdfFile.addPage();
      var imgData = canvas.toDataURL("image/jpeg", 1.0);
      pdfFile.addImage(imgData, 0, 0, canvas.width, canvas.height);
      setTimeout(()=>
      {
        console.log("inside setTimeout");
        pdfFile.save("Automations Statistics.pdf");
        this.spinnerService.isLoading.next(false);
        this.toastrService.clear();
        this.toastrService.success("Report Exported Successfully");
      }, 0)
    });
  }

  openmenu() {
    var x = document.getElementById("dropdown1");
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "block";
    }
  }
  closemenu() {
    this.searchText = "";
    var x = document.getElementById("dropdown1");
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
  }

  datesUpdated(dates) {
    this.barGraphStartDate = new Date(this.selected.startDate.toDate()).setHours(0, 0, 0);
    this.barGraphEndDate = new Date(this.selected.endDate.toDate()).setHours(23, 59, 59);
    console.log("dates changed : ", this.barGraphStartDate, this.barGraphEndDate);
  }

  dragStarted(title, relocate) {
    this.relocate = relocate;
    console.log("dragStarted : ", title);
    this.draggedGraph = title;
  }

  allowDrop(event) {
    event.preventDefault();
  }

  graphDropped(index, isDrop) {
    this.isGraphDropped = isDrop;
    this.dropIndex = index;
    if (this.personalizedCharts.length > 12) {
      this.toastrService.clear();
      this.toastrService.warning("You have already ploted all graphs");
      return;
    }

    if (this.relocate) {
      this.relocateGraph();
      return;
    }
    if(isDrop)
    {
      let obj = { title: "Loading" };
      this.personalizedCharts.splice(index, 0, obj);
    }

    let selectedGraphType;
    if(this.graphTypeMap[this.draggedGraph])
    {
      selectedGraphType = this.graphTypeMap[this.draggedGraph].graphCode;
    }
    else{
      return;
    }

     selectedGraphType = this.graphTypeMap[this.draggedGraph].graphCode;
    let chartData: any = {};
    
    switch (selectedGraphType) {
      case "1":
        this.loadGraphs(this.selectedProject);
        break;
      case "2":
        this.loadAutomationHierarchyCount();
        break;
      case "3":
        this.loadAutomationExecutionCount();
        break;
      case "4":
        this.getCumulativeAutomationRuntime();
        break;
      case "5":
        this.getAutomationModules(true, false);
        break;
      case "6":
        this.loadAutomationRuntimeAcrossUsers();
        break;
      case "7":
        this.loadUserAutomationCount();
        break;
      case "8":
        this.loadSingleAutomationHierarchy();
        break;
      case "9":
        this.getRuntimeByAutomation();
        break;
      case "10":
        this.getRuntimeByOS();
        break;
      case "11":
        this.getUserList();
        break;
      case "12":
        this.getAutomationModules(false, true);
        break;
      default:
        break;
    }

  }

  saveOrderToDb()
  {
    let order = { orderDataList : [], filterList: [] };
    let index = 0;
    this.personalizedCharts.forEach((element, i)=>
    {
      if(element.title != 'Drop Container' && element.title != 'Loading')
      {
        ++index
        let obj = { graphName: element.title, order: index};
        order.orderDataList.push(obj);
      }
    })

    // before making API storing order in local
    this.graphOrder =  order;
    if (order.orderDataList) {
      this.graphOrderMap = {};
      order.orderDataList.forEach((element) => {
        this.graphOrderMap[element["graphName"]] = Number(element["order"]);
      });
    }

    let obj1 =  { "filterName": "automation", "value": this.selectedProject, "type": "global" , "data" : []};
    let obj2 =  { "filterName": "startDate", "value": this.barGraphStartDate, "type": "global", "data" : [] };
    let obj3 =  { "filterName": "endDate", "value": this.barGraphEndDate, "type": "global",  "data" : [] };

    order.filterList.push(obj1);
    order.filterList.push(obj2);
    order.filterList.push(obj3);
    
    this.projectService.saveGraphOrder(order).subscribe((res: any) => {});
  }

  relocateGraph() {
    let relocateGraph: any;
    this.personalizedCharts.forEach((element, i) => {
      if (element.title == this.draggedGraph) {
        relocateGraph = element;
        this.personalizedCharts.splice(i, 1);
      }
    });
    this.personalizedCharts.splice(this.dropIndex, 0, relocateGraph);
    this.saveOrderToDb();
    this.manageDropContainer();
  }

  removeGraph(index) {
    if (this.personalizedCharts.length <= 4) {
      this.toastrService.clear();
      this.toastrService.warning("there should be at least 3 graphs");
      return;
    }
    this.personalizedCharts.splice(index, 1);
    this.saveOrderToDb();
    this.manageDropContainer();
  }

  disableGraph(title) {
    let isGraphExist = this.personalizedCharts.find(
      (chart) => chart.title == title
    )
      ? true
      : false;
    
    let loadCheck = this.personalizedCharts.find((chart)=> chart.title == "Loading") ? true : isGraphExist;
    
    return loadCheck;
  }

  getRandomInt(max) {
    let array = [];
    for (let i = 0; i <= max; i++) {
      array.push(Math.floor(Math.random() * 10));
    }
    return array;
  }

  expandChart(index) {
    this.selectedChart = this.personalizedCharts[index];
  }

  ngAfterViewInit() {

  }

  // this function converts the graph data to smaller version
  shortVersionConverter(graph) {
    let shrinkVersion;
    let plotData;
    if(!this.graphTypeMap[graph.title])
    {
      return null;
    }
    let selectedGraphCode = graph.title == 'Drop Container' ? '13' : this.graphTypeMap[graph.title].graphCode;
    switch (selectedGraphCode) {

      case "1":
        plotData = graph.chart[0].data;
        shrinkVersion = {
          title: graph.title,
          type: graph.type,
          labels: graph.labels,
          data: plotData,
        };
        break;

      case "2":
        plotData = [];
        graph.chart.forEach((element) => {
          let obj = { label: element.label, value: element.data };
          plotData.push(obj);
        });
        shrinkVersion = {
          title: graph.title,
          type: graph.type,
          labels: graph.labels,
          data: plotData,
        };
        break;

      case "3":
        plotData = graph.chart[0].data;
        shrinkVersion = {
          title: graph.title,
          type: graph.type,
          labels: graph.labels,
          data: plotData,
        };
        break;

      case "4":
        plotData = [];
        graph.chart.forEach((element) => {
          let obj = { label: element.label, value: element.data };
          plotData.push(obj);
        });
        shrinkVersion = {
          title: graph.title,
          type: graph.type,
          labels: graph.labels,
          data: plotData,
        };
        break;

      case "5":
        plotData = [];
        graph.chart.forEach((element) => {
          let obj = { label: element.label, value: element.data };
          plotData.push(obj);
        });
        shrinkVersion = {
          title: graph.title,
          type: graph.type,
          labels: graph.labels,
          data: plotData,
          inputs: graph.inputs
        };
        break;

      case "6":
        plotData = graph.chart[0].data;
        shrinkVersion = {
          title: graph.title,
          type: graph.type,
          labels: graph.labels,
          data: plotData,
        };
        break;

      case "7":
        plotData = [];
        graph.chart.forEach((element) => {
          let obj = { label: element.label, value: element.data };
          plotData.push(obj);
        });
        shrinkVersion = {
          title: graph.title,
          type: graph.type,
          labels: graph.labels,
          data: plotData,
        };
        break;

      case "8":
        plotData = [];
        graph.chart.forEach((element) => {
          let obj = { label: element.label, value: element.data };
          plotData.push(obj);
        });
        shrinkVersion = {
          title: graph.title,
          type: graph.type,
          labels: graph.labels,
          data: plotData,
        };
        break;

      case "9":
        plotData = [];
        graph.chart.forEach((element) => {
          let obj = { label: element.label, value: element.data };
          plotData.push(obj);
        });
        shrinkVersion = {
          title: graph.title,
          type: graph.type,
          labels: graph.labels,
          data: plotData,
        };
        break;

      case "10":
        plotData = [];
        graph.chart.forEach((element) => {
          let obj = { label: element.label, value: element.data };
          plotData.push(obj);
        });
        shrinkVersion = {
          title: graph.title,
          type: graph.type,
          labels: graph.labels,
          data: plotData,
        };
        break;

      case "11":
        plotData = [];
        graph.chart.forEach((element) => {
          let obj = { label: element.label, value: element.data };
          plotData.push(obj);
        });
        shrinkVersion = {
          title: graph.title,
          type: graph.type,
          labels: graph.labels,
          data: plotData,
          inputs: graph.inputs
        };
        break;

      case "12":
        plotData = [];
        graph.chart.forEach((element) => {
          let obj = { label: element.label, value: element.data };
          plotData.push(obj);
        });
        shrinkVersion = {
          title: graph.title,
          type: graph.type,
          labels: graph.labels,
          data: plotData,
          inputs: graph.inputs
        };
        break;

      case "13":
        shrinkVersion = {
          title: "Drop Container",
          type: "",
          labels: "",
          data: "",
        };
        break;

      default:
        break;
    }

    return shrinkVersion;
  }

  // this function converts local storage data to original version
  originalVersionConverter(graph) {
    let restoredData;
    let plotData;
    let lineGraphBorderColors = ["#39b54a", "#053367"];
    let selectedGraphCode;
    if(this.graphTypeMap[graph.title])
    {
       selectedGraphCode = graph.title == 'Drop Container' ? '13' : this.graphTypeMap[graph.title].graphCode;
    }
    else
    {
      selectedGraphCode = '14';
    }
    
    switch (selectedGraphCode) {

      case "1":
        plotData = [
          {
            data: graph.data,
            backgroundColor: this.chartBackgroundColor,
            hoverBackgroundColor: this.chartHoverBackgroundColor,
            hoverBorderColor: this.chartHoverBorderColor,
          },
        ];

        restoredData = {
          index: this.personalizedCharts.length,
          title: graph.title,
          tooltip: this.graphTooltipMap[selectedGraphCode],
          type: graph.type,
          chart: plotData,
          labels: graph.labels,
          options: this.chartOptions,
          legend: true,
          inputs: [],
        };
        break;

      case "2":
        plotData = [];
        graph.data.forEach((element, i) => {
          let obj = {
            label: element.label,
            data: element.value,
            backgroundColor: this.horizontalChartBackgroundColor[i],
            borderColor: this.horizontalChartHoverBorderColor[i],
            hoverBackgroundColor: this.horizontalChartHoverBackgroundColor[i],
            hoverBorderColor: this.horizontalChartHoverBorderColor[i],
          };
          plotData.push(obj);
        });

        restoredData = {
          index: this.personalizedCharts.length,
          title: graph.title,
          tooltip: this.graphTooltipMap[selectedGraphCode],
          type: graph.type,
          chart: plotData,
          labels: graph.labels,
          options: this.horizontalChartOptions,
          legend: true,
          inputs: [],
        };

        break;

      case "3":
        plotData = [
          {
            data: graph.data,
            backgroundColor: this.barChartBackgroundColor,
            hoverBackgroundColor: this.barChartHoverBackgroundColor,
            hoverBorderColor: this.barChartHoverBorderColor,
          },
        ];

        restoredData = {
          index: this.personalizedCharts.length,
          title: graph.title,
          tooltip: this.graphTooltipMap[selectedGraphCode],
          type: graph.type,
          chart: plotData,
          labels: graph.labels,
          options: this.barChartOptions,
          legend: false,
          inputs: [],
        };

        break;

      case "4":
        plotData = [];

        graph.data.forEach((element, i) => {
          let obj = {
            label: element.label,
            data: element.value,
            fill: false,
            backgroundColor: "#CDEBFF",
            borderColor: lineGraphBorderColors[i],
            tension: 0,
            pointBackgroundColor: lineGraphBorderColors[i],
          };
          plotData.push(obj);
        });

        restoredData = {
          index: this.personalizedCharts.length,
          title: graph.title,
          tooltip: this.graphTooltipMap[selectedGraphCode],
          type: graph.type,
          chart: plotData,
          labels: graph.labels,
          options: this.lineChartOptions,
          legend: true,
          inputs: [],
        };
        break;

      case "5":
        plotData = [];

        graph.data.forEach((element, i) => {
          let obj = {
            label: element.label,
            data: element.value,
            fill: false,
            backgroundColor: "#CDEBFF",
            borderColor: lineGraphBorderColors[i],
            tension: 0,
            pointBackgroundColor: lineGraphBorderColors[i],
          };
          console.log("testing...", graph);
          if(element.label == 'Module')
          {
            obj['pointBorderColor'] =  lineGraphBorderColors[i],
            obj['borderWidth'] =  6,
            obj['pointRadius'] = 2
          }
          plotData.push(obj);
        });

        restoredData = {
          index: this.personalizedCharts.length,
          title: graph.title,
          tooltip: this.graphTooltipMap[selectedGraphCode],
          type: graph.type,
          chart: plotData,
          labels: graph.labels,
          options: this.lineChartOptions,
          legend: true,
          inputs: graph.inputs,
        };
        this.moduleData =  graph.inputs[0].options;
        break;

      case "6":
        plotData = [
          {
            data: graph.data,
            backgroundColor: this.chartBackgroundColor,
            hoverBackgroundColor: this.chartHoverBackgroundColor,
            hoverBorderColor: this.chartHoverBorderColor,
          },
        ];

        restoredData = {
          index: this.personalizedCharts.length,
          title: graph.title,
          tooltip: this.graphTooltipMap[selectedGraphCode],
          type: graph.type,
          chart: plotData,
          labels: graph.labels,
          options: this.chartOptions,
          legend: true,
          inputs: [],
        };
        break;

      case "7":
        plotData = [];
        graph.data.forEach((element, i) => {
          let obj = {
            label: element.label,
            data: element.value,
            backgroundColor: "#002d5b",
            borderColor: "#39b54a",
            hoverBackgroundColor:"#124176"
          };
          plotData.push(obj);
        });

        restoredData = {
          index: this.personalizedCharts.length,
          title: graph.title,
          tooltip: this.graphTooltipMap[selectedGraphCode],
          type: graph.type,
          chart: plotData,
          labels: graph.labels,
          options: this.numAutoBarChartOptions,
          legend: true,
          inputs: [],
        };
        break;

      case "8":
        plotData = [];

        graph.data.forEach((element, i) => {
          let obj = {
            label: element.label,
            data: element.value,
            backgroundColor: "#002d5b",
            borderColor: "#39b54a",
            hoverBackgroundColor:"#124176"
          };
          plotData.push(obj);
        });

        restoredData = {
          index: this.personalizedCharts.length,
          title: graph.title,
          tooltip: this.graphTooltipMap[selectedGraphCode],
          type: graph.type,
          chart: plotData,
          labels: graph.labels,
          options: this.autoSubCompBarChartOptions,
          legend: true,
          inputs: [],
        };
        break;

      case "9":
        plotData = [];

        graph.data.forEach((element, i) => {
          let obj = {
            label: element.label,
            data: element.value,
            fill: false,
            backgroundColor: "#CDEBFF",
            borderColor: lineGraphBorderColors[i],
            tension: 0,
            pointBackgroundColor: lineGraphBorderColors[i],
          };
          plotData.push(obj);
        });

        restoredData = {
          index: this.personalizedCharts.length,
          title: graph.title,
          tooltip: this.graphTooltipMap[selectedGraphCode],
          type: graph.type,
          chart: plotData,
          labels: graph.labels,
          options: this.lineChartOptions,
          legend: true,
          inputs: [],
        };
        break;

      case "10":
        plotData = [];

        graph.data.forEach((element, i) => {
          let obj = {
            label: element.label,
            data: element.value,
            backgroundColor: "#002d5b",
            borderColor: "#39b54a",
            hoverBackgroundColor:"#124176"
          };
          plotData.push(obj);
        });

        restoredData = {
          index: this.personalizedCharts.length,
          title: graph.title,
          tooltip: this.graphTooltipMap[selectedGraphCode],
          type: graph.type,
          chart: plotData,
          labels: graph.labels,
          options: this.runTimeByOSBarChartOptions,
          legend: true,
          inputs: [],
        };
        break;

      case "11":
        plotData = [];

        graph.data.forEach((element, i) => {
          let obj = {
            label: element.label,
            data: element.value,
            fill: false,
            backgroundColor: "#CDEBFF",
            borderColor: lineGraphBorderColors[i],
            tension: 0,
            pointBackgroundColor: lineGraphBorderColors[i],
          };
          plotData.push(obj);
        });

        restoredData = {
          index: this.personalizedCharts.length,
          title: graph.title,
          tooltip: this.graphTooltipMap[selectedGraphCode],
          type: graph.type,
          chart: plotData,
          labels: graph.labels,
          options: this.lineChartOptions,
          legend: true,
          inputs: graph.inputs,
        };
        this.usersData =  graph.inputs[0].options;
        console.log("sample : ",graph.inputs)
        break;

      case "12":
        plotData = [];

        graph.data.forEach((element, i) => {
          let obj = {
            label: element.label,
            data: element.value,
            fill: false,
            backgroundColor: "#CDEBFF",
            borderColor: lineGraphBorderColors[i],
            tension: 0,
            pointBackgroundColor: lineGraphBorderColors[i],
          };
          plotData.push(obj);
        });

        restoredData = {
          index: this.personalizedCharts.length,
          title: graph.title,
          tooltip: this.graphTooltipMap[selectedGraphCode],
          type: graph.type,
          chart: plotData,
          labels: graph.labels,
          options: this.lineChartOptions,
          legend: true,
          inputs: graph.inputs,
        };
        break;

      case "13":
        restoredData = {
          index: 12,
          title: "Drop Container",
          tooltip: "",
          type: "",
          chart: "",
        };
      break;

      default:
        break;
    }
    return restoredData;
  }

  // this function manages drop container position
  manageDropContainer() {
    
    // this.personalizedCharts.forEach((element, i) => {
    //   if (element.title == "Drop Container") {
    //     delete element;
    //   }
    // });

    this.personalizedCharts = this.personalizedCharts.filter((element)=> element.title != 'Drop Container')

    if (this.personalizedCharts.length < 12) {
      let emptyData = {
        index: 12,
        title: "Drop Container",
        tooltip: "",
        type: "",
        chart: "",
      };
      this.personalizedCharts.splice(
        this.personalizedCharts.length,
        0,
        emptyData
      );
    }

    let shortVersion: any = [];
    this.personalizedCharts.forEach((element: any) => {
      if (this.shortVersionConverter(element) != null) {
        shortVersion.push(this.shortVersionConverter(element));
      }
    });
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let graphData = {
      graphDetails : shortVersion,
      userId : currentUser.id
    }
    localStorage.setItem("graphData", JSON.stringify(graphData));
    console.log("short version : ", this.personalizedCharts);
  }

  filterGlobalAutomation()
  {
    this.saveOrderToDb();

    this.personalizedCharts.forEach((graph, index) => {
      if(graph.title != 'Drop Container' && graph.title != 'Loading')
      {
        let selectedGraphCode = this.graphTypeMap[graph.title].graphCode;
        if (this.automationArray.includes(selectedGraphCode)) {
          this.refreshSingleChart(graph.title);
        }
      }
    });

  }

  filterGlobalDates(event)
  {
    if(event.startDate == null)
    {
        return;
    }
    setTimeout(()=>
    {
      this.saveOrderToDb();
      this.personalizedCharts.forEach((graph, index) => {
        if(graph.title != 'Drop Container' && graph.title != 'Loading')
        {
          let selectedGraphCode = this.graphTypeMap[graph.title].graphCode;
          if (this.datesArray.includes(selectedGraphCode)) {
            this.refreshSingleChart(graph.title);
          }
        }
      });
    }, 10)

  }

  getGraphDescription(chartData, graphType)
  {
    let text;
    let arr;
    let avgAutomtionRunTime;
    let selectedAutomationName =  this.projectData.find((project)=> project.id == this.selectedProject).projectName;

    switch (graphType) {
      case "1":
        text = `This chart represents sucess-failure statistics of the '${selectedAutomationName}' automation. `;
        arr = chartData.chart[0].data;
        text += `As per the data, here is the execution status : `
        chartData.labels.forEach((label, index) => {
          text +=  index == 0 ? ` ${label} : ${arr[index]}` : `, ${label} : ${arr[index]}`;
        });
      break;
      case "2":
        text = `This chart represent the subcomponents of top 5 automations. `;
        text += `As per the info, here is the detailed subcomponent count of each automation : `
        let modules = chartData.chart.find((data)=> data.label == 'modules').data;
        let suites = chartData.chart.find((data)=> data.label == 'suites').data;
        let cases = chartData.chart.find((data)=> data.label == 'cases').data;
        let steps = chartData.chart.find((data)=> data.label == 'steps').data;
        chartData.labels.forEach((label, index) => {
          text +=  ` ${label} : modules-${modules[index]}, suites-${suites[index]}, cases-${cases[index]}, steps-${steps[index]} .`;
        });
      break;
      case "3":
        text = `This chart represent the automation execution count of top 10 automations. `;
        arr = chartData.chart[0].data;
        text += `As per the data, here is the execution count : `
        chartData.labels.forEach((label, index) => {
          text +=  index == 0 ? ` ${label} : ${arr[index]}` : `, ${label} : ${arr[index]}`;
        });
      break;
      case "4":
        text = `This graph represents the cumulative running time for '${selectedAutomationName}' automation. `;
        arr = chartData.chart[0].data;
        text += `The running time of automation is ${arr[arr.length - 1]}`;
      break;
      case "5":
        text = `This graph compares the duration to complete '${selectedAutomationName}' automation and the selected module.`;
        let automation = chartData.chart.find((data)=> data.label == 'Automation');
        let module = chartData.chart.find((data)=> data.label == 'Module');
        avgAutomtionRunTime = (automation.data.reduce((accumulator, currentValue) => accumulator + currentValue, 0)/ automation.data.length);
        let avgModuleRunTime = (module.data.reduce((accumulator, currentValue) => accumulator + currentValue, 0)/ module.data.length);
        let result =  avgAutomtionRunTime/ avgModuleRunTime;
        text += `The Average runtime of automation is ${avgAutomtionRunTime} and average runtime of module is ${avgModuleRunTime}. The execution time of automation is ${result} times of module.`
      break;
      case "6":
        text = `This chart represents runtime of '${selectedAutomationName}' automation across top 5 users. `;
        arr = chartData.chart[0].data;
        text += `As per the reports, here is the runtime of a specific user : `
        chartData.labels.forEach((label, index) => {
          text +=  index == 0 ? ` ${label} : ${arr[index]}` : `, ${label} : ${arr[index]}`;
        });
      break;
      case "7":
        text = `This chart represents top 5 users holding more number of automations. `;
        arr = chartData.chart[0].data;
        text += `As per the report, here are the users with automation count : `
        chartData.labels.forEach((label, index) => {
          text +=  index == 0 ? ` ${label} : ${arr[index]}` : `, ${label} : ${arr[index]}`;
        });
      break;
      case "8":
        text = `This chart shows the subcomponents of '${selectedAutomationName}' automation. `;
        arr = chartData.chart[0].data;
        text += `Here are the subcomponents : `
        chartData.labels.forEach((label, index) => {
          text +=  index == 0 ? ` ${label} : ${arr[index]}` : `, ${label} : ${arr[index]}`;
        });
      break;
      case "9":
        text = `This line chart represents the time taken to complete '${selectedAutomationName}' automation in different time periods. `;
        arr = chartData.chart[0].data;
        avgAutomtionRunTime = (arr.reduce((accumulator, currentValue) => accumulator + currentValue, 0)/ arr.length);
        text += `As per the analytics, the average runtime of automation is ${avgAutomtionRunTime}`;
      break;
      case "10":
        text = `This chart compares the time taken to complete '${selectedAutomationName}' automation in different OS machines. `;
        arr = chartData.chart[0].data;
        text += `As per the analytics, here is runtime in different OS : `
        chartData.labels.forEach((label, index) => {
          text +=  index == 0 ? ` ${label} : ${arr[index]}` : `, ${label} : ${arr[index]}`;
        });
      break;
      case "11":
        text = `This line chart represents the time taken by a user to complete '${selectedAutomationName}' automation in different time periods. `;
        arr = chartData.chart[0].data;
        avgAutomtionRunTime = (arr.reduce((accumulator, currentValue) => accumulator + currentValue, 0)/ arr.length);
        text += `As per the analytics, the average runtime of automation is ${avgAutomtionRunTime}`;
      break;
      case "12":
        text = `This Line chart is specific to a suite. This chart represents the time taken to execute a suite in '${selectedAutomationName}' automation. `;
        arr = chartData.chart[0].data;
        avgAutomtionRunTime = (arr.reduce((accumulator, currentValue) => accumulator + currentValue, 0)/ arr.length);
        text += `The average runtime of selected suite is : ${avgAutomtionRunTime}`;
      break;
    }

    return text;
  }

   findHighestAndLowest(arr: number[]): { highest: number; lowest: number } | null {
    if (arr.length === 0) {
      return null; // Return null for an empty array
    }
  
    let highest = arr[0];
    let lowest = arr[0];
  
    for (let i = 1; i < arr.length; i++) {
      if (arr[i] > highest) {
        highest = arr[i];
      } else if (arr[i] < lowest) {
        lowest = arr[i];
      }
    }
  
    return { highest, lowest };
  }

  filterChanged(input, event)
  {
    let data = event.target.value;
    console.log(input, event.target.value);
    switch (input.name) {
      case "module":
        this.getAutomationVsModuleRuntime(data);
        break;
      case "user":
        this.getRuntimeByUser(data);
        break;
      case "module2":
        if (!this.moduleSuiteMap[data]) {
          this.toastrService.clear();
          this.toastrService.info("No suites available");
          return;
        }
        this.suiteData = this.moduleSuiteMap[data];
        this.getSuiteRuntime(this.suiteData[0]);
        break;
      case "suite":
        let selectedSuite = input.options.find((suite)=> suite.id == data);
        this.getSuiteRuntime(selectedSuite);
        break;
      default:
        break;
    }
  
  }

  checkValue(option)
  {
    console.log(option)
    return false;
  }


  ngOnDestroy() {}

}

                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       